import React, { useState, useEffect } from 'react';
import './styles.css';
import SidebarToggle from '../SidebarToggle/SidebarToggle';

/* ── All hero background collage images ── */
import imgBgKeyboard       from '../../assets/hero/bg-keyboard.png';
import imgBgPastorMic      from '../../assets/hero/bg-pastor-mic.png';
import imgBgPastorPreach   from '../../assets/hero/bg-pastor-preach.png';
import imgBgSingers        from '../../assets/hero/bg-singers.png';
import imgBgWomenWorship   from '../../assets/hero/bg-women-worship.png';
import imgChurchChildren   from '../../assets/hero/church-children.jpg';
import imgChurchMen        from '../../assets/hero/church-men.png';
import imgChurchMic        from '../../assets/hero/church-mic.jpg';
import imgChurchPastor     from '../../assets/hero/church-pastor.jpg';
import imgChurchPodium     from '../../assets/hero/church-podium.png';
import imgChurchSinging    from '../../assets/hero/church-singing.jpg';
import imgChurchWomen      from '../../assets/hero/church-women.png';
import imgChurchWorship    from '../../assets/hero/church-worship.png';
import imgChurchYouth      from '../../assets/hero/church-youth.png';
import imgPastorBg         from '../../assets/hero/pastor-bg.png';
import imgPhotoCakeCut     from '../../assets/hero/photo-cake-cut.jpg';
import imgPhotoMenRow      from '../../assets/hero/photo-men-row.png';
import imgPhotoPastorKids  from '../../assets/hero/photo-pastor-kids.png';
import imgPhotoWomenGroup  from '../../assets/hero/photo-women-group.png';
import imgPhotoYouthStage  from '../../assets/hero/photo-youth-stage.png';
import imgPreacher1        from '../../assets/hero/preacher-point1.png';
import imgPreacher2        from '../../assets/hero/preacher-point2.png';
import imgSingersMicNobg   from '../../assets/hero/singers-mic-nobg.png';

/* ── Floating photo card images ── */
import pop1 from '../../assets/hero/pop1.jpg';
import pop2 from '../../assets/hero/pop2.jpg';
import pop3 from '../../assets/hero/pop3.jpg';
import pop4 from '../../assets/hero/pop4.jpg';
import pop5 from '../../assets/hero/pop5.jpg';
import pop6 from '../../assets/hero/pop6.jpg';
import pop7 from '../../assets/hero/pop7.jpg';
import pop8 from '../../assets/hero/pop8.jpg';
import pop9 from '../../assets/hero/pop9.jpg';
import pop10 from '../../assets/hero/pop10.jpg';
import imgPurple from '../../assets/loveworldsingers/img_purple.jpg';

const COLLAGE = [
  { src: imgBgKeyboard,      cls: 'c2'  },
  { src: imgBgPastorMic,     cls: 'c3'  },
  { src: imgBgPastorPreach,  cls: 'c4'  },
  { src: imgBgSingers,       cls: 'c5'  },
  { src: imgBgWomenWorship,  cls: 'c6'  },
  { src: imgChurchChildren,  cls: 'c9'  },
  { src: imgChurchMen,       cls: 'c10' },
  { src: imgChurchMic,       cls: 'c11' },
  { src: imgChurchPastor,    cls: 'c12' },
  { src: imgChurchPodium,    cls: 'c13' },
  { src: imgChurchSinging,   cls: 'c14' },
  { src: imgChurchWomen,     cls: 'c15' },
  { src: imgChurchWorship,   cls: 'c16' },
  { src: imgChurchYouth,     cls: 'c17' },
  { src: imgPastorBg,        cls: 'c19' },
  { src: imgPhotoCakeCut,    cls: 'c20' },
  { src: imgPhotoMenRow,     cls: 'c21' },
  { src: imgPhotoPastorKids, cls: 'c22' },
  { src: imgPhotoWomenGroup, cls: 'c23' },
  { src: imgPhotoYouthStage, cls: 'c24' },
  { src: imgPreacher1,       cls: 'c25' },
  { src: imgPreacher2,       cls: 'c26' },
  { src: imgSingersMicNobg,  cls: 'c27' },
];

/* Combined pool of 34 rich photos */
const POP_IMAGES = [
  pop1, pop2, pop3, pop4, pop5, pop6, pop7, pop8, pop9, pop10,
  imgBgKeyboard, imgBgPastorMic, imgBgPastorPreach, imgBgSingers, imgBgWomenWorship,
  imgChurchChildren, imgChurchMen, imgChurchMic, imgChurchPastor, imgChurchPodium,
  imgChurchSinging, imgChurchWomen, imgChurchWorship, imgChurchYouth, imgPastorBg,
  imgPhotoCakeCut, imgPhotoMenRow, imgPhotoPastorKids, imgPhotoWomenGroup, imgPhotoYouthStage,
  imgPreacher1, imgPreacher2, imgSingersMicNobg, imgPurple
];

/* 12-Position Clockwise Circular Track for the continuous Image Train around hero perimeter */
const POP_POSITIONS = [
  { id: 0,  top: '5%',   left: '3%',   rot: '-4deg', width: '200px', height: '130px' }, // 1. Top-Left Corner
  { id: 1,  top: '4%',   left: '24%',  rot: '2deg',  width: '195px', height: '128px' }, // 2. Top-Left Center
  { id: 2,  top: '4%',   left: '46%',  rot: '-2deg', width: '195px', height: '128px' }, // 3. Top-Center Right
  { id: 3,  top: '5%',   right: '3%',  rot: '3deg',  width: '200px', height: '130px' }, // 4. Top-Right Corner
  { id: 4,  top: '32%',  right: '2%',  rot: '-3deg', width: '195px', height: '128px' }, // 5. Upper Right Margin
  { id: 5,  top: '58%',  right: '2%',  rot: '2deg',  width: '195px', height: '128px' }, // 6. Lower Right Margin
  { id: 6,  bottom: '5%', right: '3%', rot: '-4deg', width: '205px', height: '135px' }, // 7. Bottom-Right Corner
  { id: 7,  bottom: '4%', right: '28%', rot: '3deg',  width: '200px', height: '130px' }, // 8. Bottom-Right Center
  { id: 8,  bottom: '4%', left: '28%',  rot: '-2deg', width: '200px', height: '130px' }, // 9. Bottom-Left Center
  { id: 9,  bottom: '5%', left: '3%',   rot: '4deg',  width: '205px', height: '135px' }, // 10. Bottom-Left Corner
  { id: 10, top: '58%',  left: '2%',   rot: '-3deg', width: '195px', height: '128px' }, // 11. Lower Left Margin
  { id: 11, top: '32%',  left: '2%',   rot: '2deg',  width: '195px', height: '128px' }  // 12. Upper Left Margin
];

const Header = () => {
  const [activeItems, setActiveItems] = useState([]);
  const [isLive, setIsLive] = useState(false);

  useEffect(() => {
    // Poll live status every 60 seconds so the hero button
    // activates automatically without needing a page refresh
    const checkLiveStatus = async () => {
      try {
        const ytPromise = fetch(`${process.env.REACT_APP_API_URL || 'https://ceindiazone2.in'}/api/youtube/status`)
          .then(res => res.json())
          .then(data => !!(data && data.isLive))
          .catch(() => false);

        const hlsPromise = fetch('https://cdn.itassist.one/church/stream/index.m3u8', { cache: 'no-store' })
          .then(res => res.ok)
          .catch(() => false);

        const [ytLive, hlsLive] = await Promise.all([ytPromise, hlsPromise]);
        setIsLive(ytLive || hlsLive);
      } catch {
        setIsLive(false);
      }
    };

    checkLiveStatus(); // Run immediately on mount
    const liveInterval = setInterval(checkLiveStatus, 60000); // then every 60s

    let isMounted = true;
    const timeouts = [];
    let imageIndex = 0;
    let circularStep = 0;

    const spawnNext = () => {
      if (!isMounted) return;

      setActiveItems(prevActive => {
        // Enforce exact circular step sequence around the perimeter
        const targetPos = POP_POSITIONS[circularStep % POP_POSITIONS.length];
        circularStep++;

        // Filter POP_IMAGES to ONLY images that are NOT currently active
        const activeSrcs = prevActive.map(item => item.src);
        const availableImages = POP_IMAGES.filter(img => !activeSrcs.includes(img));

        const selectedImg = availableImages.length > 0 
          ? availableImages[imageIndex % availableImages.length] 
          : POP_IMAGES[imageIndex % POP_IMAGES.length];

        imageIndex++;

        const id = Date.now() + Math.random();
        const newItem = { id, src: selectedImg, pos: targetPos, visible: false };

        // Schedule visibility transitions
        const t1 = setTimeout(() => {
          if (!isMounted) return;
          setActiveItems(prev => prev.map(item => item.id === id ? { ...item, visible: true } : item));
        }, 60);

        // Stay visible for 5.5 seconds to form a continuous flowing train
        const t2 = setTimeout(() => {
          if (!isMounted) return;
          setActiveItems(prev => prev.map(item => item.id === id ? { ...item, visible: false } : item));
        }, 5500);

        // Clean up from state after fade out completes
        const t3 = setTimeout(() => {
          if (!isMounted) return;
          setActiveItems(prev => prev.filter(item => item.id !== id));
        }, 6400);

        timeouts.push(t1, t2, t3);

        return [...prevActive, newItem];
      });
    };

    // Initial delay of 1s after page load
    const initialDelay = setTimeout(() => {
      spawnNext(); // Train starts at Top-Left
      
      // Every 1.0 second, spawn the next card in clockwise circular sequence
      const intervalId = setInterval(() => {
        spawnNext();
      }, 1000);

      timeouts.push(intervalId);
    }, 1000);

    timeouts.push(initialDelay);

    return () => {
      isMounted = false;
      clearInterval(liveInterval);
      timeouts.forEach(t => clearTimeout(t) || clearInterval(t));
    };
  }, []);

  const handleAttendService = () => {
    const serviceSection = document.getElementById('service');
    if (serviceSection) {
      serviceSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <section className="hero-section">

      {/* Full art collage — ultra-low opacity */}
      <div className="hero-art-collage">
        {COLLAGE.map(({ src, cls }) => (
          <img key={cls} src={src} className={`art-img ${cls}`} alt="" />
        ))}
      </div>

      {/* Asynchronous floating photo cards continuous image train */}
      <div className="hero-pop-container">
        {activeItems.map(({ id, src, pos, visible }) => (
          <div
            key={id}
            className={`floating-card ${visible ? 'card-in' : 'card-out'}`}
            style={{
              top: pos.top || 'auto',
              left: pos.left || 'auto',
              right: pos.right || 'auto',
              bottom: pos.bottom || 'auto',
              transform: `rotate(${pos.rot}) scale(${visible ? 1 : 0.8})`,
              width: pos.width,
              height: pos.height,
            }}
          >
            <div className="floating-card-inner">
              <img src={src} alt="Church Experience" className="floating-card-img" />
              <div className="floating-card-glow" />
            </div>
          </div>
        ))}
      </div>

      {/* Floating light blobs — red, green, blue stage lights */}
      <div className="hero-blob hero-blob-red" />
      <div className="hero-blob hero-blob-green" />
      <div className="hero-blob hero-blob-blue" />

      <SidebarToggle />
      <div className="container hero-container-center">
        <div className="hero-content centered">
          <h1 className="hero-title">CHRIST EMBASSY <br />PUNE</h1>
          <p className="hero-subtitle">...giving your life a meaning</p>
          <div className="hero-buttons centered">

            <button 
              className={`btn-secondary ${isLive ? 'is-live-btn' : ''}`} 
              onClick={handleAttendService}
              style={isLive ? { animation: 'liveBlink 1.2s ease-in-out infinite alternate', backgroundColor: '#e74c3c', color: '#fff', borderColor: '#e74c3c' } : {}}
            >
              {isLive && <span className="pulsating-dot is-live" style={{marginRight: '8px', display: 'inline-block'}}></span>}
              {isLive ? 'WATCH LIVE NOW' : 'Watch Live Service'}
            </button>
          </div>
        </div>
      </div>
      <div className="hero-contact-us">
        Contact Us: +918040184671 / +919529607156
      </div>
    </section>
  );
};

export default Header;